import script from "./RegisterIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterIndex.vue?vue&type=script&setup=true&lang=js"

import "./RegisterIndex.vue?vue&type=style&index=0&id=2df57451&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df57451"]])

export default __exports__